export const METERS_PER_SECOND_PER_KNOT = 0.514285714;

export const KNOT_VALUES = [...new Array(70).map((_, i) => i)];

export const getMetersPerSecondByKnots = (knots: number): number => knots * METERS_PER_SECOND_PER_KNOT;

export const getKnotsByMetersPerSecond = (metersPerSecond: number): number => metersPerSecond / METERS_PER_SECOND_PER_KNOT;
